import { useMemo } from 'react'

import { Dropdown } from '@circlefin/components'
import { DocumentType } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import type { DropdownProps } from '@circlefin/components/lib/Dropdown'
import type { SelectListItem } from '@circlefin/components/lib/SelectList'

export type FormOfIdProps = Omit<
  DropdownProps<DocumentType>,
  'items' | 'children'
> & {
  loading: boolean
}

const ID_OPTIONS = [DocumentType.passport, DocumentType.usdl, DocumentType.usid]

export const FormOfId: React.FC<FormOfIdProps> = ({
  label,
  loading,
  onChange,
  value,
  disabled,
  ...props
}) => {
  const { t } = useTranslation('l3Onboarding')

  const data: Array<SelectListItem<DocumentType>> = useMemo(
    () =>
      Object.values(DocumentType)
        .filter((option) => Object.values(ID_OPTIONS).includes(option))
        .map((option) => ({
          label: t(`forms.common.formOfId.options.${DocumentType[option]}`),
          value: DocumentType[option],
        })),
    [t],
  )

  return (
    <Dropdown
      disabled={disabled}
      inputLoading={loading}
      items={data}
      label={t`forms.common.formOfId.label`}
      onBlur={props.onBlur}
      onChange={onChange}
      value={value}
      {...props}
    >
      <Dropdown.Options items={data} maxMenuItems={6} />
    </Dropdown>
  )
}
